var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAddRow = function SvgAddRow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3,3v-.2l.4-.6.7-.2h11.9v1H1.3ZM1.3,6v-1h12.9v1H1.3ZM1.3,9v-1h7.7v1H1.3ZM1.6,12v-1h6v1H1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,7c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5,4.5-2,4.5-4.5-2-4.5-4.5-4.5ZM14,12h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3,14.9H1.8c-.3,0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,14.9h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3,10.9H1.8c-.3,0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3,7H1.8c-.3,0-.5-.2-.5-.5V2.5c0-.3.2-.5.5-.5h3.5"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAddRow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/addRow.6a09f4a6e1d7a407d6f1165ac6c474e3.svg";